// @ts-nocheck
import { isInternetExplorer6, isInternetExplorer7, isInternetExplorer8 } from "./Browser";
import { DomQuery } from "./Dom";
import { Point } from "./Geometry";

function MetaKeys() {
  this.alt = false;
  this.shift = false;
  this.control = false;

  this.asURLParameters = function () {
    var result = "";

    if (this.alt)
      result += "&alt=1";

    if (this.control)
      result += "&control=1";

    if (this.shift)
      result += "&shift=1";

    return result;
  }

  this.asXMLAttributes = function () {
    var result = "";

    if (this.alt)
      result += " alt=\"1\"";

    if (this.control)
      result += " control=\"1\"";

    if (this.shift)
      result += " shift=\"1\"";

    return result;
  }
}

if (typeof (Event) != "undefined") {
  Event.prototype.getKey = function () {
    var result = this.keyCode;

    if (result == null || result == 0)
      result = this.which;

    return result;
  }

  Event.prototype.getMetaKeys = function () {
    var result = new MetaKeys();

    result.alt = this.altKey;
    result.control = this.ctrlKey;
    result.shift = this.shiftKey;

    return result;
  }

  Event.prototype.getPosition = function () {
    var result = new Point(0, 0);
    var source = this.getSource();

    result.x = this.offsetX;
    result.y = this.offsetY;

    if (result.x == null)
      result.x = this.layerX - source.offsetLeft - 1;

    if (result.y == null)
      result.y = this.layerY - source.offsetTop - 1;

    return result;
  }

  Event.prototype.getSource = function () {
    var result = this.target;

    if (!result)
      result = this.srcElement;

    return result;
  }

  Event.prototype.stopHandling = function () {
    this.cancelBubble = true;
    this.cancel = true;

    if (this.stopPropagation)
      this.stopPropagation();

    if (this.preventDefault)
      this.preventDefault();
    else
      this.returnValue = false;

    return false;
  }

  Event.prototype.getButton = function () {
    if (isInternetExplorer6() || isInternetExplorer7() || isInternetExplorer8()) {
      if (this.button & 1)
        return 0;
      else if (this.button & 4)
        return 2;
      else if (this.button & 2)
        return 1;
    }
    else
      return this.button;
  }
}

export function getEvent(event) {
  if (!event)
    return window.event;
  else
    return event;
}

export function DataChangedEvent(field) {
  this.field = field;
}

export function VisibilityChangedEvent(field) {
  this.field = field;
}

export function AvailableSizeChangedEvent() {
}

export class CountChangedEvent {
  constructor(count) {
    this.count = count;
  }
}

export function distributeEvent(event) {
  var query = new DomQuery(document.body);
  var object = event.field;

  query.traversePostOrder(
    function (element) {
      if (element.component !== undefined && element.component !== object && element.component.handleEvent !== undefined)
        element.component.handleEvent(event);
    }
  );
}

export function distributeEventUpHierarchy(event, component) {
  event.handled = false;
  component = component.parentComponent;

  while (component !== null && !event.handled) {
    component.handleEvent(event);
    component = component.parentComponent;
  }
}

export function distributeEventDownHierarchy(event, component) {
  let index = 0;
  const children = component.childComponents;

  while (!event.handled && index < children.length) {
    const child = children[index];
    child.handleEvent(event);

    distributeEventDownHierarchy(event, child);
    index++;
  }
}

export function clickElement(element) {
  var event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true
  });

  element.dispatchEvent(event);
}
